//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'rb-combo-mini-slider',
  props: {
    /*
     * Image Props
     */
    imageDesktop: String,
    imageTablet: String,
    imageMobile: String,
    imageAlt: String,

    /*
     * Pill Props
     */
    pill: String,

    /*
     * Flip Props
     */
    verticalFlip: {
      type: Boolean,
      default: false,
    },
    horizontalFlip: {
      type: Boolean,
      default: false,
    },
    verticalFlipOnlyDesktop: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    sliderConfig() {
      return {
        slidesPerView: 1.18,
        spaceBetween: 16,
        breakpoints: {
          // when window width is >= 769px
          769: {
            slidesPerView: 1,
          },
        },
      }
    },
  },
}
